<script setup lang="ts">
/** Placeholder visuel pendant la vérification OIDC (même gabarit que vue nationale + fil d’Ariane). */
const BREADCRUMB_SEGMENTS = 4
const GRID_COLUMNS = 6
const ITEMS_PER_COLUMN = 6
</script>

<template>
  <section
    class="authgate-shell national"
    aria-busy="true"
    aria-live="polite"
    aria-label="Chargement de l’application"
  >
    <div class="authgate-shell__breadcrumb-wrap">
      <nav class="authgate-shell__breadcrumb" aria-hidden="true">
        <ol class="authgate-shell__breadcrumb-list">
          <li
            v-for="segmentIndex in BREADCRUMB_SEGMENTS"
            :key="'bc-' + segmentIndex"
            class="authgate-shell__breadcrumb-item"
          >
            <span v-if="segmentIndex > 1" class="authgate-shell__breadcrumb-sep">&gt;</span>
            <span class="authgate-shell__breadcrumb-segment" />
          </li>
        </ol>
      </nav>
    </div>

    <div class="authgate-shell__page-title" aria-hidden="true" />

    <div class="columns-wrapper columns-wrapper--skeleton">
      <div class="columns-grid">
        <div v-for="colIndex in GRID_COLUMNS" :key="'sk-col-' + colIndex" class="col">
          <div class="col-header col-header--skeleton" />
          <div class="items-list">
            <div
              v-for="itemIndex in ITEMS_PER_COLUMN"
              :key="'sk-item-' + colIndex + '-' + itemIndex"
              class="item item--skeleton"
            />
          </div>
        </div>
      </div>
    </div>

    <p class="authgate-shell__sr-only">Vérification de votre session…</p>
  </section>
</template>

<style scoped lang="scss">
@use "~/assets/scss/partials/orga/national-grid" as *;
@use "~/assets/scss/partials/elpdl/colors" as c;
@use "~/assets/scss/partials/elpdl/spacing" as *;

.authgate-shell__breadcrumb-wrap {
  margin-bottom: $spacing-m;
  min-height: 1.5rem;
}

.authgate-shell__breadcrumb {
  display: inline-block;
}

.authgate-shell__breadcrumb-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0 $spacing-xs;
  margin: 0;
  padding: 0;
  list-style: none;
}

.authgate-shell__breadcrumb-item {
  display: inline-flex;
  align-items: center;
  gap: $spacing-xs;
}

.authgate-shell__breadcrumb-sep {
  color: c.$enedis-neutral-600;
  font-size: 0.875rem;
}

.authgate-shell__breadcrumb-segment {
  display: inline-block;
  height: 1rem;
  border-radius: 2px;
  background: c.$enedis-neutral-40;
  animation: authgate-shell-shimmer 1.2s ease-in-out infinite;
}

.authgate-shell__breadcrumb-item:nth-of-type(odd) .authgate-shell__breadcrumb-segment {
  width: 3rem;
}

.authgate-shell__breadcrumb-item:nth-of-type(even) .authgate-shell__breadcrumb-segment {
  width: 4rem;
}

.authgate-shell__breadcrumb-item:nth-of-type(3) .authgate-shell__breadcrumb-segment {
  width: 5rem;
}

.authgate-shell__page-title {
  max-width: 280px;
  height: 2rem;
  margin: $spacing-xs auto $spacing-l;
  border-radius: $spacing-2xs;
  background: c.$enedis-neutral-40;
  animation: authgate-shell-shimmer 1.2s ease-in-out infinite;
}

@keyframes authgate-shell-shimmer {
  0%,
  100% {
    opacity: 0.65;
  }
  50% {
    opacity: 1;
  }
}

.authgate-shell__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
